import { useMemo } from 'react'

import { useExpandedRows } from '../../../../../contexts/expandedRowsContext'
import { TableRow } from '../../../../../elements/TableRow'
import { PeriodValue } from '../../../../../types/inputTypes'
import { mapBalanceSheetBalances } from '../../../../../utils/balanceMappers'
import { buildTableData } from '../../../../../utils/buildTableData'
import { BalanceSheetInputRowComponent } from '../../types/inputTypes'
import { BalanceSheetCells } from '../BalanceSheetCells'

interface BalanceSheetTableBodyProps {
  reportData: BalanceSheetInputRowComponent[]
  periods: PeriodValue[]
}

export const BalanceSheetTableBody = ({ reportData, periods }: BalanceSheetTableBodyProps) => {
  const { expandedRows } = useExpandedRows()

  const tableData = useMemo(
    () => buildTableData(reportData, expandedRows, periods, mapBalanceSheetBalances),
    [expandedRows, reportData, periods],
  )

  return (
    <tbody>
      {tableData.map((row) => (
        <TableRow row={row} key={row.id}>
          <BalanceSheetCells row={row} periods={periods} />
        </TableRow>
      ))}
    </tbody>
  )
}
